import React from "react";
import { Button } from "reactstrap";
import style from "./Trading.module.scss";
import LineForm from "./LineForm";
import { fetchCParties } from "./FormFields";

const Column = ({
  side,
  rows,
  loading,
  needFX,
  FXPair,
  newRow,
  delRow,
  counterparties,
  tradeRoutes,
  onChange,
  massiveMode,
  maxDecimals,
}) => {
  return (
    <div className={style.column} style={cstyle(side)}>
      {rows.length == 0 && <EmptyRows />}
      {rows.map((r, index) => (
        <React.Fragment key={`c-${r.id}`}>
          <LineForm
            row={r}
            needFX={needFX}
            FXPair={FXPair}
            loading={loading}
            delRow={() => delRow(side, r.id)}
            fetchCParties={(v) => fetchCParties(v, counterparties)}
            tradeRoutes={tradeRoutes}
            onChange={(props) => onChange(side, r.id, props)}
            massiveMode={massiveMode}
            maxDecimals={maxDecimals}
          />
          {index != rows.length - 1 && <hr />}
        </React.Fragment>
      ))}
      {!massiveMode && <AddRow newRow={() => newRow(side)} disabled={loading} />}
    </div>
  );
};

const AddRow = ({ newRow, disabled }) => (
  <Button className={style.btnNew} onClick={() => newRow()} disabled={disabled} color={"primary"} size="sm">
    Add new row
  </Button>
);

const EmptyRows = () => (
  <div className={style.empty}>
    <span className="h5 text-muted">Empty</span>
  </div>
);

const cstyle = (side) => {
  if (side == "buy")
    return {
      background: "rgba(44, 177, 90, 0.08)",
      border: "solid 1px rgba(44, 177, 90, 1)",
      marginRight: "5px",
    };
  else
    return {
      background: "rgba(243, 75, 75, 0.08)",
      border: "solid 1px rgba(243, 75, 75, 1)",
      marginLeft: "5px",
    };
};

export default Column;
